'use strict';

angular.module('schoolbushubApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('monitoring', {
                parent: 'admin',
                url: '/monitoring',
                data: {
                    authorities: ['ROLE_SEONADMIN', 'ROLE_ADMIN', 'ROLE_CUSTOMERADMIN'],
                    pageTitle: 'School Bus Hub'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/monitoring/monitoring.html',
                        controller: 'MonitoringCtrl'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('monitoring');
                        return $translate.refresh();
                    }]
                }
            });
    });
